import React from 'react';
import { Volume2, Camera, Radio, MapPin } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TankBanner = ({ token }) => {
  const handlePlayVoice = async () => {
    try {
      const res = await fetch(`${API_URL}/api/voice/generate`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          text: "Welcome to OverWatch! I've got eyes on everything. Pick your data overlays and let's see what's happening out there.",
          character: "tank",
          mood: "friendly"
        })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.audio_url) {
          const audio = new Audio(data.audio_url);
          audio.play();
        }
      }
    } catch (err) {
      console.error('Voice error:', err);
    }
  };

  return (
    <div className="absolute top-[52px] left-0 right-0 z-20 bg-gradient-to-r from-amber-950/95 via-slate-900/98 to-amber-950/95 border-b border-amber-800/40 backdrop-blur-sm shadow-lg">
      <div className="flex items-center justify-between px-4 py-2.5 max-w-screen-2xl mx-auto">
        {/* Tank's Avatar & Message */}
        <div className="flex items-center gap-3">
          <div className="relative">
            <img 
              src="/images/tank.png"
              alt="Tank"
              className="w-10 h-10 rounded-full border-2 border-amber-500/50 shadow-lg shadow-amber-500/20 object-cover"
            />
            <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 rounded-full border-2 border-slate-900 animate-pulse" />
          </div>
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="font-bold text-amber-400 text-sm">Tank says:</span>
              <button
                onClick={handlePlayVoice}
                className="p-1 rounded-full bg-amber-500/20 hover:bg-amber-500/30 transition-colors"
                title="Hear Tank say this"
                data-testid="tank-voice-btn"
              >
                <Volume2 className="w-3 h-3 text-amber-400" />
              </button>
            </div>
            <p className="text-xs text-amber-200/80 italic truncate">
              "Welcome to OverWatch! Pick your data overlays and let's see what's happening."
            </p>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="hidden md:flex items-center gap-4 text-xs">
          <div className="flex items-center gap-1.5 text-slate-400">
            <Camera className="w-3.5 h-3.5 text-blue-400" />
            <span>15K+ Cameras</span>
          </div>
          <div className="flex items-center gap-1.5 text-slate-400">
            <Radio className="w-3.5 h-3.5 text-teal-400" />
            <span>32 Scanners</span>
          </div>
          <div className="flex items-center gap-1.5 text-slate-400">
            <MapPin className="w-3.5 h-3.5 text-amber-400" />
            <span>29 States</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TankBanner;
